import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
const includes = ['Descarga inmediata', 'Acceso de por vida', 'Compatible con cualquier dispositivo'];
export const PricingSection: React.FC = () => {
  return <section id="pricing" className="py-20 lg:py-28 bg-white" data-id="element-88">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <motion.div className="text-center max-w-3xl mx-auto mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-90">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-91">
            Empieza hoy a recuperar tu energía y bienestar.
          </h2>
          <p className="text-lg text-gray-600 mt-5" data-id="element-92">
            Accede inmediatamente a una guía práctica de 21 días con hábitos
            sencillos que te ayudarán a reducir el impacto del estrés, mejorar
            tu descanso y recuperar tu bienestar paso a paso.
          </p>
        </motion.div>

        <motion.div className="max-w-lg mx-auto bg-white rounded-3xl border-2 border-brand-lightmint shadow-xl overflow-hidden" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-93">
          <div className="p-8 sm:p-10 text-center bg-brand-lightmint/30" data-id="element-94">
            <div className="inline-block mb-2" data-id="element-95">
              <span className="text-xl text-gray-400 line-through font-medium" data-id="element-96">
                $27
              </span>
            </div>
            <div className="text-6xl font-bold text-brand-emerald mb-4 tracking-tight" data-id="element-97">
              $9.99
            </div>
            <p className="text-lg font-medium text-brand-charcoal" data-id="element-98">
              Solo $9.99 USD
            </p>
          </div>

          <div className="p-8 sm:p-10" data-id="element-99">
            <ul className="space-y-4 mb-10" data-id="element-100">
              {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-101">
                  <CheckCircle2 className="w-6 h-6 text-brand-emerald flex-shrink-0" data-id="element-102" />
                  <span className="text-gray-700 font-medium" data-id="element-103">{item}</span>
                </li>)}
            </ul>

            <a href="https://pay.hotmart.com/L105883257P" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart({
            content_name: 'Resetea tu Cortisol en 21 Días',
            value: 9.99,
            currency: 'USD'
          })} className="block w-full py-4 px-6 text-center text-lg font-bold text-white bg-brand-emerald hover:bg-brand-emeraldHover rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 mb-6" data-id="element-104">
              QUIERO MI GUÍA AHORA — $9.99
            </a>

            <div className="flex items-start justify-center gap-2 text-sm text-gray-500 font-medium" data-id="element-105">
              <Lock className="w-4 h-4 text-brand-emerald flex-shrink-0 mt-0.5" data-id="element-106" />
              <span className="text-center" data-id="element-107">
                Compra segura procesada por Hotmart, una de las plataformas
                líderes en la venta de productos digitales.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};